import { computed, makeObservable } from 'mobx';

import Configuracao from '@/util/Configuracao.js';

import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

/**
 * Enum para opções de filtro de partes intimadas por DJE.
 *
 * @readonly
 * @constant
 */
// prettier-ignore
const OPCOES_FILTRO_INTIMACAO_DJE = {
    TODAS:              { id: 'TODAS',              descricao: 'Todas as partes intimadas via DJE'                        },
    NENHUMA:            { id: 'NENHUMA',            descricao: 'Todas as partes SEM intimação via DJE'                    },
    PELO_MENOS_UMA:     { id: 'PELO_MENOS_UMA',     descricao: 'Pelo menos uma parte intimada via DJE'                    },
    PELO_MENOS_UMA_SEM: { id: 'PELO_MENOS_UMA_SEM', descricao: 'Pelo menos uma parte SEM intimação via DJE'               },
    INAPLICAVEL:        { id: 'INAPLICAVEL',        descricao: 'Sem possibilidade de intimação via DJE (processo do SIJ)' }
};

export default class FiltroIntimacaoDomicilioEletronico extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = false;
    opcoesFiltro = Object.values(OPCOES_FILTRO_INTIMACAO_DJE);

    constructor(props) {
        super(props);

        makeObservable(this, {
            exibicao: true,
            selecaoMultipla: true,
            opcoesFiltro: true,
            tipoConjuntoOpcoes: true,
            totalizador: true,
            tipo: true,
            label: true,
            getValorOpcao: true,
            getDescricao: true,
            renderCarregando: true,
            carregandoDadosComplementares: computed
        });
    }

    get label() {
        return 'Partes intimadas via Domicílio Judicial Eletrônico (DJe) - exclusivo para PJe';
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    get totalizador() {
        return [
            OPCOES_FILTRO_INTIMACAO_DJE.NENHUMA.id,
            OPCOES_FILTRO_INTIMACAO_DJE.PELO_MENOS_UMA.id,
            OPCOES_FILTRO_INTIMACAO_DJE.INAPLICAVEL.id
        ];
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    getValorOpcao(registro) {
        if (registro.processo.origem !== Configuracao.ORIGEM_PJE) {
            return [OPCOES_FILTRO_INTIMACAO_DJE.INAPLICAVEL.id];
        }

        if (!this.store.mapaProcessosPartes) {
            return [];
        }

        const partesProcesso = this.store.mapaProcessosPartes[registro.processo?.numeroCompleto];
        const partes = partesProcesso?.partes;

        if (!partes || partes.length === 0) {
            return [];
        }

        const totalPartes = partes.length;
        const totalComIntimacaoDJe = partes.filter((parte) => parte.intimacaoDomicilioEletronico?.dataIntimacao).length;

        const subconjuntosAtendidos = [];

        // Nenhuma parte intimada via DJE
        if (totalComIntimacaoDJe === 0) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_INTIMACAO_DJE.NENHUMA.id);
        }

        // Pelo menos uma parte intimada via DJE
        if (totalComIntimacaoDJe > 0) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_INTIMACAO_DJE.PELO_MENOS_UMA.id);
        }

        // Todas as partes intimadas via DJE
        if (totalComIntimacaoDJe === totalPartes) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_INTIMACAO_DJE.TODAS.id);
        }

        // Pelo menos uma parte SEM intimação via DJE (Inverso de "Todas as partes intimadas via DJE")
        if (totalComIntimacaoDJe < totalPartes) {
            subconjuntosAtendidos.push(OPCOES_FILTRO_INTIMACAO_DJE.PELO_MENOS_UMA_SEM.id);
        }

        return subconjuntosAtendidos;
    }

    getDescricao(valor) {
        const opcao = this.opcoesFiltro.find((opcao) => opcao.id === valor);
        return opcao ? opcao.descricao : 'INFORMAÇÃO DESCONHECIDA';
    }

    renderCarregando() {
        return this.renderCircularProgress('dados relativos a domicílio judicial eletrônico...');
    }
}
